import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Phone } from 'lucide-react';
const navLinks = [{
  name: 'Home',
  href: '#hero'
}, {
  name: 'Services',
  href: '#services'
}, {
  name: 'Our Work',
  href: '#gallery'
}, {
  name: 'Testimonials',
  href: '#testimonials'
}, {
  name: 'Offer',
  href: '#offer'
}, {
  name: 'Guarantee',
  href: '#guarantee'
}, {
  name: 'FAQ',
  href: '#faq'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>, href: string) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(false);
    setTimeout(() => {
      const id = href.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  };
  return <header className="fixed top-0 left-0 right-0 z-50 bg-[#1B2E1B] shadow-lg" data-id="element-202">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        {/* Logo centered */}
        <div className="flex justify-center py-2" data-id="element-204">
          <a href="#hero" onClick={e => scrollToSection(e, '#hero')} className="block" data-id="element-205">
            <img src="https://cdn.magicpatterns.com/uploads/8UAMqXX221Y2fkV41Qc9pU/Photoroom_20260321_140530.png" alt="RMorales Lawn Service" className="h-14 md:h-16 w-auto" data-id="element-206" />
          </a>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center justify-center border-t border-white/10 py-2 gap-6" data-id="element-207">
          <nav className="flex items-center space-x-6" data-id="element-208">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-white/90 hover:text-[#C5A55A] text-sm font-medium transition-colors" data-id="element-209">
                {link.name}
              </a>)}
          </nav>
          <a href="tel:8325034445" className="inline-flex items-center px-5 py-2 rounded-full bg-[#C5A55A] text-[#1B2E1B] font-bold text-sm hover:bg-[#d4b46a] transition-colors shadow-md hover:shadow-lg" data-id="element-210">
            <Phone className="w-4 h-4 mr-2" data-id="element-211" />
            832-503-4445
          </a>
        </div>

        {/* Mobile: hamburger button */}
        <div className="lg:hidden absolute top-4 right-4" data-id="element-212">
          <button onClick={() => setIsOpen(!isOpen)} className="z-50 p-2 rounded-md text-white hover:bg-white/10 transition-colors" aria-label="Toggle menu" data-id="element-213">
            {isOpen ? <X className="w-6 h-6" data-id="element-214" /> : <Menu className="w-6 h-6" data-id="element-215" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation (Accordion Style) */}
      <AnimatePresence data-id="element-216">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="lg:hidden overflow-hidden bg-[#243524] border-t border-white/10 absolute top-full left-0 right-0 shadow-xl" data-id="element-217">
            <div className="px-4 py-6 space-y-1 max-h-[80vh] overflow-y-auto" data-id="element-218">
              {navLinks.map((link, index) => <motion.div key={link.name} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.05
          }} onClick={e => scrollToSection(e, link.href)} className="block px-4 py-4 text-base font-medium text-white/90 hover:text-[#C5A55A] hover:bg-white/5 rounded-lg transition-colors border-b border-white/5 last:border-0 cursor-pointer" data-id="element-219">
                  {link.name}
                </motion.div>)}
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: navLinks.length * 0.05
          }} className="pt-6 pb-2 px-4" data-id="element-220">
                <a href="tel:8325034445" className="flex items-center justify-center w-full px-5 py-4 rounded-xl bg-[#C5A55A] text-[#1B2E1B] font-bold text-lg hover:bg-[#d4b46a] transition-colors shadow-md" data-id="element-221">
                  <Phone className="w-5 h-5 mr-2" data-id="element-222" />
                  Call Now
                </a>
              </motion.div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}